// extracted by mini-css-extract-plugin
module.exports = {"container":"i_Cc","wrapper":"i_Cd","informer":"i_Ce","no-informer":"i_Cf"};